import type { EntityBase, ShorthandEntityDefinition } from 'entities/EntityDefinition';
import { oikos, rw } from 'entities/EntityKeys';
import type { PortalEntity } from 'entities/oikos/Portal';
import type { CampaignEntity } from 'entities/rw/campaign/Campaign';

export interface CampaignPortalEntity extends EntityBase {
    portal: PortalEntity;
    campaign: CampaignEntity;
    tag: string;
}

const shorthand: ShorthandEntityDefinition<CampaignPortalEntity> = {
    key: rw.portal.Campaign,
    creatable: true,
    labelFields: 'tag',
    fields: [
        { key: 'tag', editable: true },
        { one: oikos.Portal, required: true, crossDb: true },
        { one: rw.campaign.Campaign, required: true },
    ],
};

export default shorthand;
